import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { Path, RoutePath } from 'src/app/shared/route';
import { AuthService } from 'src/app/services/auth/auth.service';

export const emailUnsubscribeGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const userId = route.queryParamMap.get('user');
  const router = inject(Router);

  const redirectUrl = router.createUrlTree(RoutePath.getPath(Path.landing).fullPath);

  if (!userId || !userId.length) return redirectUrl;

  return authService.getEmailSubscriptionData(userId).pipe(
    map(() => true),
    catchError(() => of(redirectUrl)),
  );
};
